export const ZONE_LOADING = "ZONE_LOADING";
export const ZONE_ERROR = "ZONE_ERROR";
export const ZONE_GET_LIST = "ZONE_GET_LIST";
export const ZONE_GET_ALL = "ZONE_GET_ALL";
export const ZONE_GET_TEMPLATES = "ZONE_GET_TEMPLATES";
export const ZONE_GET_FILTERS = "ZONE_GET_FILTERS";
export const ZONE_GET_TYPES = "ZONE_GET_TYPES";
export const ZONE_ADD = "ZONE_ADD";



// WEBPACK FOOTER //
// ./src/actions/zone/constants.js